import React from 'react';
import loaderPlane from './images/loaderPlane';
import Lottie from 'react-lottie';
import {isMobileOnly} from 'react-device-detect';
import PlaneLoaderAnimation from '../../../animations/plane.json';

export default function PlaneLoader(props) {
  return (
    <>
      {props.animated ? (
        <Lottie
          options={{animationData: PlaneLoaderAnimation, loop: true, autoplay: true}}
          width={!isMobileOnly && 500}
          height={!isMobileOnly && 500}
        />
      ) : (
        <div className='spinner'>
          <svg xmlns='http://www.w3.org/2000/svg' width='58.187' height='56.591' viewBox='0 0 58.187 56.591'>
            <defs></defs>
            <g id='Group_458' transform='translate(-1641.033 5078.766)'>
              <g id='noun_Plane_972456' transform='rotate(-9 -31430.919 -12963.894)'>
                <path
                  id='Path_17'
                  d='M4.179 14.577l-.479-.059-1.363-2.277L.06 10.874 0 10.4l.69-.69a1.015 1.015 0 0 1 .854-.285l1.607.23 2.464-2.9-5.558-3.38L0 2.9l.672-.672a1 1 0 0 1 .908-.274l7.413 1.483L11.987.444a1.52 1.52 0 0 1 2.147 0 1.519 1.519 0 0 1 0 2.147l-2.99 2.99L12.623 13a1 1 0 0 1-.275.907l-.671.672-.477-.059-3.377-5.556-2.9 2.463.23 1.607a1.012 1.012 0 0 1-.284.853z'
                  className='cls-1'
                />
              </g>
              <g id='noun_loading_125181' transform='translate(1641.033 -5061.704)'>
                <path
                  id='Path_18'
                  d='M80.338 58.833a.653.653 0 0 0 .356.383l1.917.828a.78.78 0 0 0 .274.055.648.648 0 0 0 .575-.39 28.589 28.589 0 0 0 1.746-5.437.654.654 0 0 0-.089-.493.682.682 0 0 0-.411-.288l-2.054-.438a.613.613 0 0 0-.157-.014.643.643 0 0 0-.616.514 26.551 26.551 0 0 1-1.534 4.807c.013.007-.076.34-.007.473z'
                  className='cls-1'
                  transform='translate(-27.033 -37.915)'
                />
                <path
                  id='Path_20'
                  d='M30.8 81.857a.608.608 0 0 1 .555-.4.648.648 0 0 1 .226.034 25.975 25.975 0 0 0 4.019 1.126.609.609 0 0 1 .39.26.635.635 0 0 1 .1.459l-.4 2.047a.609.609 0 0 1-.26.39.6.6 0 0 1-.322.1.421.421 0 0 1-.13-.014 28.916 28.916 0 0 1-4.532-1.259.618.618 0 0 1-.342-.315.627.627 0 0 1-.021-.472z'
                  className='cls-1'
                  transform='translate(-11.185 -46.876)'
                />
                <path
                  id='Path_21'
                  d='M44.822 83.638h.034c.418 0 .842-.007 1.26-.021a26.263 26.263 0 0 0 3.738-.431.39.39 0 0 1 .089-.007.607.607 0 0 1 .623.493l.39 2.04a.61.61 0 0 1-.1.459.591.591 0 0 1-.39.253 29.929 29.929 0 0 1-4.266.493c-.459.021-.924.027-1.383.027a.58.58 0 0 1-.431-.185.568.568 0 0 1-.171-.431l.014-2.088a.615.615 0 0 1 .593-.602z'
                  className='cls-1'
                  transform='translate(-15.653 -47.418)'
                />
                <path
                  id='Path_22'
                  d='M5.634 38.369a.61.61 0 0 1 .5.7c-.144.842-.24 1.7-.3 2.533a.609.609 0 0 1-.589.568h-.056l-2.081-.13a.613.613 0 0 1-.418-.205.591.591 0 0 1-.151-.445c.062-.945.178-1.91.336-2.862a.631.631 0 0 1 .246-.4.578.578 0 0 1 .336-.11.664.664 0 0 1 .116.007z'
                  className='cls-1'
                  transform='translate(-2.511 -33.179)'
                />
                <path
                  id='Path_23'
                  d='M19.729 75.606a.6.6 0 0 1 .459-.226.591.591 0 0 1 .4.13 26.091 26.091 0 0 0 3.369 2.266.6.6 0 0 1 .288.37.614.614 0 0 1-.055.466l-1.027 1.814a.611.611 0 0 1-.514.308.711.711 0 0 1-.315-.075 29.071 29.071 0 0 1-3.81-2.559.607.607 0 0 1-.226-.411.584.584 0 0 1 .13-.445z'
                  className='cls-1'
                  transform='translate(-7.479 -44.958)'
                />
                <path
                  id='Path_24'
                  d='M2.65 47.492a.6.6 0 0 1 .425-.205l2.081-.116h.021a.6.6 0 0 1 .623.575 26.033 26.033 0 0 0 .377 3.136.606.606 0 0 1-.486.705l-2.047.377c-.027.007-.062.007-.089.014a.569.569 0 0 1-.363-.11.617.617 0 0 1-.253-.39A29.663 29.663 0 0 1 2.5 47.93a.623.623 0 0 1 .15-.438z'
                  className='cls-1'
                  transform='translate(-2.499 -36.064)'
                />
                <path
                  id='Path_25'
                  d='M74.325 68.416a.6.6 0 0 1 .472-.246.641.641 0 0 1 .383.123l1.684 1.253a.621.621 0 0 1 .24.4.565.565 0 0 1-.116.452 28.741 28.741 0 0 1-3.841 4.211.637.637 0 0 1-.39.157.6.6 0 0 1-.466-.2l-1.4-1.547a.606.606 0 0 1 .041-.856 27.547 27.547 0 0 0 3.393-3.747z'
                  className='cls-1'
                  transform='translate(-24.012 -42.685)'
                />
                <path
                  id='Path_26'
                  d='M58.983 80.261l.034-.014c.308-.116.6-.233.883-.356a26.55 26.55 0 0 0 3.321-1.732.575.575 0 0 1 .3-.089.6.6 0 0 1 .534.288l1.1 1.773a.632.632 0 0 1 .075.459.616.616 0 0 1-.274.377 29.987 29.987 0 0 1-3.756 1.944c-.349.151-.705.288-1.034.418a.491.491 0 0 1-.2.041.574.574 0 0 1-.26-.055.6.6 0 0 1-.322-.336l-.746-1.931a.609.609 0 0 1 .345-.787z'
                  className='cls-1'
                  transform='translate(-20.187 -45.807)'
                />
                <path
                  id='Path_27'
                  d='M7.294 31.683a.642.642 0 0 1 .349.308.611.611 0 0 1 .027.466c-.219.616-.418 1.267-.6 1.986a.606.606 0 0 1-.568.452.731.731 0 0 1-.171-.021L4.3 34.346a.607.607 0 0 1-.431-.746c.212-.808.438-1.541.692-2.239a.6.6 0 0 1 .767-.377z'
                  className='cls-1'
                  transform='translate(-2.925 -30.95)'
                />
                <path
                  id='Path_28'
                  d='M9.907 67.967l1.726-1.167a.608.608 0 0 1 .842.164 25.632 25.632 0 0 0 2.273 2.9.609.609 0 0 1 .157.438.621.621 0 0 1-.2.425l-1.547 1.4a.637.637 0 0 1-.39.157h-.048a.605.605 0 0 1-.418-.2 28.656 28.656 0 0 1-2.561-3.273.6.6 0 0 1-.089-.459.568.568 0 0 1 .255-.385z'
                  className='cls-1'
                  transform='translate(-4.751 -42.222)'
                />
                <path
                  id='Path_29'
                  d='M4.9 57.544l1.979-.637a.473.473 0 0 1 .171-.027.61.61 0 0 1 .6.425c.26.808.541 1.554.849 2.28.123.288.253.561.4.856a.6.6 0 0 1 .027.472.629.629 0 0 1-.315.349l-1.876.9a.725.725 0 0 1-.246.062.648.648 0 0 1-.226-.034.6.6 0 0 1-.342-.315l-.031-.065c-.144-.294-.288-.6-.418-.918-.356-.828-.678-1.691-.965-2.568a.642.642 0 0 1 .034-.466.627.627 0 0 1 .359-.314z'
                  className='cls-1'
                  transform='translate(-3.123 -39.126)'
                />
              </g>
            </g>
          </svg>
        </div>
      )}

      <div className={`spinner-txt ${props.animated ? 'animated-loader' : ''}`}>{props.text}</div>
    </>
  );
}
